var shoppingCart = {
    deleteOrderline: function(id){
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            url: window.location.href,
            data: {action: 'verwijderUitWinkelwagen', winkelwagenRegelId:id},
            success: function(data)
            {
                replaceContent(data);
                $.fancybox.hideLoading();
                shoppingCart.init();
            }
        });
    },

    showShippingTypes: function(id, orderLine){
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            data: {'do' : 'showComponent', 'module' : 'Webshop', 'args[naam]' : 'VerzendkostenTypes', 'winkelwagen' : '1', 'id' : id,orderLine:orderLine},
            success: function(data){
                $.fancybox(data);
                $('.del-block').click(function(){
                    var orderLine = 0;
                    if (typeof($(this).attr('data-order-line')) !== "undefined" && $(this).attr('data-order-line').length > 0){
                        orderLine = 1;
                    }
                    $('.del-block-active').removeClass('del-block-active');
                    $(this).addClass('del-block-active');
                    shoppingCart.updateDeliveryType($(this).attr('data-days'), id, orderLine);
                })
            }
        })
    },

    updateDeliveryType: function(days, id, orderLine){

        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            data: {'action' : 'updateDeliveryType', 'days': days, 'id' : id, orderLine: orderLine},
            success: function(){
                $.ajax({
                    url: window.location.href,
                    success: function(data){
                        replaceContent(data);
                        $.fancybox.close();
                        $.fancybox.hideLoading();
                        shoppingCart.init();
                    }
                })
            }
        })
    },

    refreshShoppingCart: function(step){
        $.fancybox.showLoading();
        $.ajax({
            url: 'webshop/winkelwagen/' + step + '/',
            success: function(data){
                replaceContent(data);
                $.fancybox.close();
                $.fancybox.hideLoading();
                shoppingCart.init();
            }
        })
    },

    handleShippingAddress: function(differentShippingAddress){
        $('#aflever-wrapper').empty();
        if (parseInt(differentShippingAddress) === 1){
            $.fancybox.showLoading();
            $.ajax({
                type: 'post',
                data: {'do' : 'showComponent', 'module' : 'Webshop', 'args[naam]' : 'WinkelwagenAdresVelden', 'prefix' : 'shipping_address'},
                success: function(data){
                    $.fancybox.hideLoading();
                    $('#aflever-wrapper').html(data);
                    shoppingCart.init();
                    zipcode.init();
                }
            })
        }
    },

    submitCreateAccount: function(form){

        // var requiredFields1 = ['type_bestelling', 'aanhef', 'afleveradres'];
        var requiredFields1 = ['aanhef', 'afleveradres'];
        var requiredFields2 = ['voornaam', 'achternaam', 'invoice_address[straat]', 'invoice_address[postcode]', 'invoice_address[huisnummer]', 'invoice_address[land]', 'email'];
        var errors = 0;
        var field;

        for (var i=0; i<requiredFields2.length; i++){
            field = form.find($(':input[name="' + requiredFields2[i] + '"]'));
            field.css('border-color', '#ebebec');
            if (field.length === 0 || field.val().length === 0){
                if (field.length > 0){
                    field.css('border-color', 'red');
                }
                errors++;
            }
        }
        for (var i=0; i<requiredFields1.length; i++){
            field = form.find($(':input[name="' + requiredFields1[i] + '"]'));
            field.next('label').css('color', '#000000');
            if ($(':input[name*="' + requiredFields1[i] + '"]:checked').length === 0){
                field.next('label').css('color', 'red');
                errors++;
            }
        }
        if (errors > 0){
            alert('Niet alle velden zijn (juist) ingevuld, controleer de velden en probeer het opnieuw');
        } else {
            $.fancybox.showLoading();
            $.ajax({
                type: 'post',
                dataType: 'json',
                data: {action: 'CheckEmail', username: $('#mailadres').val()},
                success: function(data){
                    $.fancybox.hideLoading();
                    if (data.success){
                        var data = $('#form-new-customer').serialize();
                        data += '&action=AddCustomer';
                        $.ajax({
                            dataType: 'json',
                            type: 'post',
                            data: data,
                            success: function(data){
                                if (data.success){
                                    window.location.reload();
                                } else {
                                    alert('Er is een technische fout opgetreden, probeer het opnieuw of raadpleeg onze klantenservice');
                                }
                            }
                        });
                    } else {
                        $.fancybox(data.message);
                    }
                }
            })
        }
    },

    updateAddress: function(type, orderId){
        if (typeof(orderId) === "undefined"){
            orderId = null;
        }
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            data: {'do' : 'showComponent', 'module': 'webshop', 'args[naam]' : 'UpdateAddress', 'prefix' : type, orderId: orderId},
            success: function(data){
                $.fancybox(data);
                if (type != 'contact_info'){
                    zipcode.init();
                }
                $('#form-update-address').submit(function(){
                    shoppingCart.submitUpdateAddress($(this));
                    return false;
                });
            }
        })
    },

    submitUpdateAddress: function(form){
        $.fancybox.showLoading();
        var data = form.serialize();
        data += '&do=showComponent';
        data += '&module=webshop';
        data += '&args[naam]=UpdateAddress';
        data += '&action=submit';
        $.ajax({
            type: 'post',
            dataType: 'json',
            data: data,
            success: function(data){
                $.fancybox.hideLoading();
                if (data.success) {
                    if ($('#form-drukproef').length > 0) {
                        $.fancybox('<h2>Uw gegevens</h2><p>Uw gegevens zijn succesvol gewijzigd, de pagina wordt herladen...</p>');
                        drukproef.refreshYourInfo();
                    } else {
                        $.fancybox('<h2>Uw gegevens</h2><p>Uw gegevens zijn succesvol gewijzigd</p>');
                        shoppingCart.refreshYourInfo();
                        shoppingCart.refreshShoppingCartRight();
                    }
                } else if (typeof(data.message) !== "undefined" && data.message.length > 0){
                    $.fancybox('<h2>Fout</h2><p>' + data.message + '</p>');
                } else {
                    alert('Er is een technische fout opgetreden, probeer het opnieuw of raadpleeg onze klantenservice');
                }
            }
        })
    },

    refreshYourInfo: function(){
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            data: {'do' : 'showComponent', 'module' : 'webshop', 'args[naam]' : 'WinkelwagenIngelogdUwgegevens', 'orderId' : $('#wrapper-uw-gegevens').attr('data-order-id')},
            success: function(data){
                $('#wrapper-uw-gegevens').empty().append(data);
                shoppingCart.init();
                $.fancybox.hideLoading();
            }
        })
    },

    updateShippingMethod: function(method){
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            data: {'action' : 'updateShippingMethod', 'method' : method},
            success: function(data){
                // shoppingCart.refreshShoppingCartRight();
                $.fancybox.hideLoading();
            }
        })
    },

    refreshShoppingCartRight: function(step){
        if (typeof(step) === "undefined"){
            step = 3;
        }
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            data: {'do' : 'showComponent', 'module' : 'webshop', 'args[naam]' : 'WinkelwagenSamenvatting', 'params[step]' : step},
            success: function(data){
                $('#cart-right').replaceWith(data);
                $.fancybox.hideLoading();
                shoppingCart.init();
            }
        })
    },

    validateStep: function(step, elem){
        switch (step){
            case '5':
                if ($('.betaal-list li.active').length > 0){
                    $('#betaalmethode_id').val($('.betaal-list li.active').attr('data-id'));
                    $.fancybox('<h1>Een ogenblik geduld</h1><p>Een ogenblik geduld, uw bestelling wordt verwerkt.</p>')
                    $('#form-payment-method').submit();
                } else {
                    $.fancybox('<h1>Betaalmethode</h1><p>Voordat u verder kunt gaan dient u eerst een betaalmethode te kiezen</p>');
                }
                break;
            default:
                window.location.href = elem.prop('href');
                break;
        }
    },
    handleFileUploaded: function(data, shoppingCartLineId){
        if (data.success){
            $.fancybox.showLoading();
            $.ajax({
                type: 'post',
                data: {fileData: JSON.stringify(data), action: 'uploadedFile', shoppingCartLineId: shoppingCartLineId},
                success: function(data){
                    replaceContent(data);
                    $.fancybox.hideLoading();
                    shoppingCart.init();
                }
            })
        } else {
            // word al afgevangen bij offerte aanvragen file upload
        }

    },
    updateCartAmount: function(shoppingCartLineId, amount ){
        $.fancybox('<form method="post" id="formUpdateCartAmount"><input type="hidden" name="action" value="updateCartAmount" /><input type="hidden" name="shoppingCartLineId" value="' + shoppingCartLineId + '" /><h1 style="width: 270px;">Aantal wijzigen</h1><p>Kies het gewenste aantal</p><input style="width: 188px; display: block; margin: 0px auto;" type="number" value="' + amount + '" name="amount" required min="1" /><input style="margin-top: 16px;" type="submit" value="Aantal wijzigen" class="standaard-button" /></form>');
        $('#formUpdateCartAmount').off('submit').on('submit', function(){
            $.fancybox.showLoading();
            $.ajax({
                type: 'post',
                data: $(this).serialize(),
                success: function(data){
                    replaceContent(data);
                    $.fancybox.hideLoading();
                    $.fancybox.close();
                    shoppingCart.init();
                }
            });
            return false;
        })
    },

    updateCartAmountOrder: function(shoppingCartLineId){

        var row = $('.cart-update-amount-order[data-id="' + shoppingCartLineId + '"]');
        var currentAmount = row.attr('data-current');
        var sr = JSON.parse(row.attr('data-sr'));
        var select = '<select name="amount" style="display: block; width: 100%;">';
        for (var i=0; i<sr.length; i++){
            select += '<option ' + (parseInt(currentAmount) === parseInt(sr[i].amount) ? 'selected' : '') + ' value="' + sr[i].amount + '">' + sr[i].amount + '</option>';
        }
        select += '</select>';

        $.fancybox('<form method="post" id="formUpdateCartAmount"><input type="hidden" name="action" value="updateCartAmountOrder" /><input type="hidden" name="shoppingCartLineId" value="' + shoppingCartLineId + '" /><h1 style="width: 270px;">Aantal wijzigen</h1><p>Kies het gewenste aantal</p>' + select + '<input style="margin-top: 16px;" type="submit" value="Aantal wijzigen" class="standaard-button" /></form>');
        $('#formUpdateCartAmount').off('submit').on('submit', function(){
            $.fancybox.showLoading();
            $.ajax({
                type: 'post',
                data: $(this).serialize(),
                success: function(data){
                    $.ajax({
                        url: window.location.href,
                        success: function(data){
                            replaceContent(data);
                            $.fancybox.hideLoading();
                            $.fancybox.close();
                            shoppingCart.init();
                        }
                    })
                }
            });
            return false;
        })
    },
    updateCartAmountOffer: function(shoppingCartLineId, amount ){
        $.fancybox('<form method="post" id="formUpdateCartAmount"><input type="hidden" name="action" value="updateCartAmount" /><input type="hidden" name="shoppingCartLineId" value="' + shoppingCartLineId + '" /><h1 style="width: 270px;">Aantal wijzigen</h1><p>Kies het gewenste aantal</p><input style="width: 188px; display: block; margin: 0px auto;" type="number" value="' + amount + '" name="amount" required min="1" /><input style="margin-top: 16px;" type="submit" value="Aantal wijzigen" class="standaard-button" /></form>');
        $('#formUpdateCartAmount').off('submit').on('submit', function(){
            $.fancybox.showLoading();
            $.ajax({
                type: 'post',
                data: $(this).serialize(),
                success: function(data){
                    replaceContent(data);
                    $.fancybox.hideLoading();
                    $.fancybox.close();
                    shoppingCart.init();
                }
            });
            return false;
        })
    },

    init: function(){

        $('.cart-update-amount').click(function(){
            shoppingCart.updateCartAmount($(this).attr('data-id'), $(this).attr('data-amount'));
            return false;
        });

        $('.cart-update-amount-order').click(function(){
            shoppingCart.updateCartAmountOrder($(this).attr('data-id'), $(this).attr('data-amount'));
            return false;
        });



        $('.sc-bestand-btn').off('click').click(function(){
            $(this).next('.file-upload').click();
            return false;
        });

        $('#form-file-upload .file-upload').off('change').on('change', function(){
            var file = $(this);
            if ($(this).val().length > 0){
                var shoppingCartLineId = $(this).attr('data-shopping-cart-line-id');
                requestOffer.uploadFile(file[0], shoppingCart.handleFileUploaded, shoppingCartLineId);
            }
        });

        $('.cart-btn--bevestig .next-step').off('click').click(function(){
            var step = $(this).attr('data-step');
            shoppingCart.validateStep(step, $(this));
            return false;
        });

        requestOffer.checkFields();
        setTimeout(function(){
            requestOffer.checkFields();
        }, 1000);
        $('.klant-block  :input').off('change keyup keydown').on('change keyup keydown', function(){
            setTimeout(function(){
                requestOffer.checkFields();
            }, 500)
        });
        $('.login-block :input').off('change keyup keydown').on('change keyup keydown', function(){
            setTimeout(function(){
                requestOffer.checkFields();
            }, 500)
        });
        $('.fancybox-btw').click(function(){
            var html = $('#btwnummer-popup').html();
            $.fancybox(html);
            return false;
        });
        $('body').on('submit', '#form-btw-nummer', function(){
            $.fancybox.showLoading();
            $.ajax({
                type: 'post',
                data: $(this).serialize(),
                success: function(data){
                    var result = data[0];
                    if (result == '1'){
                        $.fancybox('Het BTW nummer is succesvol opgeslagen');
                        shoppingCart.refreshShoppingCartRight();
                        shoppingCart.refreshYourInfo();
                    } else {
                        $.fancybox('Er is een fout opgetreden, probeer het opnieuw');
                        $.fancybox.hideLoading();
                    }
                }
            });
            return false;
        });

        $('.update-invoice-address').off('click').click(function(){
            var orderId = null;
            if (typeof($(this).attr('data-order-id')) !== "undefined"){
                orderId = $(this).attr('data-order-id');
            }
            shoppingCart.updateAddress('invoice_address', orderId);
            return false;
        });
        $('.update-delivery-address').off('click').click(function(){
            var orderId = null;
            if (typeof($(this).attr('data-order-id')) !== "undefined"){
                orderId = $(this).attr('data-order-id');
            }
            shoppingCart.updateAddress('delivery_address', orderId);
            return false;
        });
        $('.update-contact-info').off('click').click(function(){
            shoppingCart.updateAddress('contact_info');
            return false;
        });

        $('.remove-cart').off('click').click(function(){
            shoppingCart.deleteOrderline($(this).attr('data-id'));
            return false;
        });

        $('.shopShippingTypes').off('click').click(function(){
            var orderLine = 0;
            if (typeof($(this).attr('data-order-line')) !== "undefined" && $(this).attr('data-order-line').length > 0){
                orderLine = 1;
            }
            shoppingCart.showShippingTypes($(this).attr('data-id'), orderLine);
            return false;
        });

        $('.cart-login').off('click').click(function(){
            shoppingCart.login($('#email2').val(), $('#Wachtwoord').val());
            return false;
        });

        $('#form-cart-login').off('submit').submit(function(){
            shoppingCart.login($('#email2').val(), $('#Wachtwoord').val());
            return false;
        })

        $('.forgot-password').off('click').click(function(){
            shoppingCart.forgotPassword();
            return false;
        });

        $('.cart-info-new').off('click').click(function(){
           shoppingCart.newUser($('#email1').val());
           return false;
        });

        $(':input[name="afleveradres"]').off('change').change(function(){
           shoppingCart.handleShippingAddress($(':input[name="afleveradres"]:checked').val());
        });

        $('#form-new-customer').off('submit').on('submit', function(){
            shoppingCart.submitCreateAccount($(this));
            return false;
        });

        $('.submit-new-customer').off('click').on('click', function(){
            shoppingCart.submitCreateAccount($('#form-new-customer'));
            return false;
        });

        $(':input[name="bezorgopties"]').off('change').on('change', function(){
            shoppingCart.updateShippingMethod($(':input[name="bezorgopties"]:checked').val());
        });


        $( ".tooltip" ).tooltip({
            position: {
                my: "center bottom",
                at: "center top"
            }
        });


    },

    newUser: function(email){
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            dataType: 'json',
            data: {action: 'CheckEmail', username: email},
            success: function(data){
                $.fancybox.hideLoading();
                if (data.success){
                    shoppingCart.showNewCustomerForm(email);
                } else {
                    $.fancybox(data.message);
                }
            }
        })
    },

    showNewCustomerForm: function(email){
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            data: {'action' : 'newCustomer', 'email' : email},
            success: function(data){
                $('#container-content').empty().append(data);
                $.fancybox.hideLoading();
                shoppingCart.init();
                zipcode.init();
            }
        })
    },

    login: function(username, password){
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            dataType: 'json',
            data: {action: 'login', username: username, password: password},
            success: function(data){
                $.fancybox.hideLoading();
                if (data.success){
                    window.location.reload();
                } else {
                    $.fancybox(data.message);
                }
            }
        })
    },

    forgotPassword: function(){
        $.fancybox.showLoading();
        $.ajax({
            url: 'webshop/wachtwoord-vergeten/',
            success: function(data){
                $.fancybox(data);
                $.fancybox.hideLoading();
            }
        });
    }

};

jQuery(function(){
    shoppingCart.init();
});


function initWinkelwagen()
{


    jQuery(".bestand-sticker-container .bestand-afhandeling-keuze").click(function() {
        /* Radio Button */
        var disabled = $(this).data('disabled');
        if(!disabled) {
            $(this).parent().find('.bestand-optie-radio-item-leeg').removeClass("radio-aan-kleur");
            jQuery(this).find('.bestand-optie-radio-item-leeg').toggleClass("radio-aan-kleur");
            $(this).parent().find('.bestand-optie-radio-item-vol').removeClass("radio-aan");
            jQuery(this).find('.bestand-optie-radio-item-vol').toggleClass("radio-aan");
        }
    }); 

    jQuery(".betalen-stap4-container .betaal-keuze-item").click(function() {   
        /* Radio Button */
        jQuery('.betalen-stap4-container .betaal-keuze-item-input-leeg').removeClass("radio-aan-kleur");
        jQuery(this).find('.betaal-keuze-item-input-leeg').toggleClass("radio-aan-kleur");
        jQuery('.betalen-stap4-container .betaal-keuze-item-input-vol').removeClass("radio-aan");
        jQuery(this).find('.betaal-keuze-item-input-vol').toggleClass("radio-aan");
    });

    jQuery(".winkelwagen-stap-1-verzending-container .verzending-keuze").click(function() {   
        /* Radio Button */
        jQuery('.winkelwagen-stap-1-verzending-container .verzending-keuze-item-input-leeg').removeClass("radio-aan-kleur");
        jQuery(this).find('.verzending-keuze-item-input-leeg').toggleClass("radio-aan-kleur");
        jQuery('.winkelwagen-stap-1-verzending-container .verzending-keuze-item-input-vol').removeClass("radio-aan");
        jQuery(this).find('.verzending-keuze-item-input-vol').toggleClass("radio-aan");
    }); 

    jQuery('.bestand-afhandeling-keuze').click(function(){
        var disabled = $(this).data('disabled');
        if(!disabled) {
            jQuery('.bestand-afhandeling-keuze').removeClass("bestand-afhandeling-keuze-selected");
            jQuery(this).addClass("bestand-afhandeling-keuze-selected");
        }
    });  

    jQuery('.betaal-keuze-item').click(function(){
        jQuery('.betaal-keuze-item').removeClass("bestand-afhandeling-keuze-selected");
        jQuery(this).addClass("bestand-afhandeling-keuze-selected"); 
    });    

    jQuery(".winkelwagen-gegevens-rechts-account-geen-account").click(function() { 
        jQuery('.geen-account-leeg').addClass("radio-aan-kleur");
        jQuery('.geen-account-vol').addClass("radio-aan");
    }); 

    jQuery(':input[name="spoedlevering"]:checked').parents('.verzending-keuze').trigger('click');
    jQuery(':input[name="spoedlevering"]:checked').trigger('click');

    /*
    jQuery('#afwijkend-afleveradres').click(function(){ 
    jQuery('#afwijkend-afleveradres-container').slideToggle(700);   
    });   

    jQuery('#afwijkend-factuuradres').click(function(){
    jQuery('#afwijkend-factuuradres-container').slideToggle(700); 
    });
    */

    $('.change-number').click(changeNumber);

    var submitten = false;

    
    if ($('#al_klant_1').length > 0)
    {
        toggleAlKlant($('#al_klant_1').is(':checked'));
    }
    if ($('#zakelijke_klant_1').length > 0)
    {
        toggleZakelijk($('#zakelijke_klant_1').is(':checked'));
    }
    if ($('#afwijkend-afleveradres').length > 0)
    {
        toggleAfwijkendAdres('afleveradres', $('#afwijkend-afleveradres').is(':checked'));
    }
    if ($('#afwijkend-factuuradres').length > 0)
    {
        toggleAfwijkendAdres('factuuradres', $('#afwijkend-factuuradres').is(':checked'));
    }

    $('.verwijder-ontwerp').click(verwijderOntwerp);

    // $('.melding-error').hide();

    $('.file-upload-winkelwagen').each(function() {
        var $this = $(this);
        var url = $this.data('url');
        var id = $this.data('id');
        $this.fileupload({
            url: url,
            formData: {
                action: 'Upload',
                id: id
            },
            dataType: 'json',
            add: function (e, data) {
                $.fancybox.showLoading();
                data.submit();
            },
            done: function (e, data) {
                var file = data.result.files[0];

                var $this = $('input[data-id='+ id + ']');
                var $parent = $this.closest('.bestand-afhandeling-keuze').first();

                if (file.url.match(/\.(jpg|jpeg|png|gif)$/)) {
                    var $img = $parent.find('img.image');
                    var $a = $parent.find('.bestand');
                    $a.hide();
                    $img.attr('src', file.url);
                    $img.parent().show();
                    $img.show();
                }else{
                    var $a = $parent.find('.bestand');
                    var $img = $parent.find('img.image');
                    $img.hide();
                    $a.attr('href', file.url);
                    $a.parent().show();
                    $a.show();
                    $a.find('img').show();
                }

                $parent.find('.text').hide();
                $parent.find('.afbeelding-plaatsen-upload-winkelwagen-container').hide();
                $parent.find('.verwijder-ontwerp').show();

                $.fancybox.hideLoading();
                hideOnlineOntwerp($parent.prev());
                showUploadOntwerp($parent);


            },
            error: function(e, data) {
                window.scrollTo(0, 0);
                $('.melding-error').first().fadeIn('slow', function() {
                   setTimeout(function() {
                       $('.melding-error').first().fadeOut('slow');
                   }, 1000);
                });
                $.fancybox.hideLoading();
            },
            progressall: function (e, data) {
                var progress = parseInt(data.loaded / data.total * 100, 10);
            }
        }).prop('disabled', !$.support.fileInput)
            .parent().addClass($.support.fileInput ? undefined : 'disabled');
    });

   // $('.bestand-sticker-container input[name=bestand-afhandeling]').click(updateMethod);
    $('.bestand-sticker-container input[name=bestand-afhandeling]').on('mousedown click mouseup', updateMethod);

    $('.edit-number').click(function(e) {
        e.preventDefault();
        $(this).parent().parent().find('.edit-aantal').slideToggle('slow');
        return false;
    });

    $('.betaal-keuze-item-input input[type=radio]').click(function() {
        var value = $(this).val();
        var toeslag = $(this).data('toeslag');

        var totaal = parseFloat($('input[name=totaal_incl]').val());
        var subtotaal_ecxl = parseFloat($('input[name=subtotaal_excl]').val());
        var btw = parseFloat($('input[name=btw]').val());
        var producten = $('input[name=totaal_excl]').val();
        var verzend = $('input[name=verzend_kosten]').val();

        if(toeslag !== undefined && toeslag > 0) {
            
            var totaalToeslag = (parseFloat(producten) + parseFloat(verzend)) / 100 * toeslag;
            var subTotaal = subtotaal_ecxl + totaalToeslag;
            var totaal = subTotaal * 1.21;
            var btw = totaal - subTotaal;
            
            $('.subtotaal-excl').text(number_format(subTotaal,2,',','.'));
            $('.btw-prijs').text(number_format(btw,2,',','.'));
            $('.totaal').text(number_format(totaal,2,',','.'));
            $('#rij-betaalkosten').show().find('span').html(number_format(totaalToeslag,2,',','.'));
        }
        else
        {
            $('.totaal').text(number_format(totaal,2,',','.'));
            $('.subtotaal-excl').text(number_format(subtotaal_ecxl,2,',','.'));
            $('.btw-prijs').text(number_format(btw,2,',','.'));
            $('#rij-betaalkosten').hide(); 
        }
    });
}

function addToeslag(bedrag, toeslag)
{
    return (bedrag * (1 + (toeslag / 100))).toFixed(2).replace('.', ',');
}

function changeNumber()
{
    var $this = $(this);
    var $parent = $this.parent();
    var $number = $parent.find('.number');

    var call = $this.data('call');
    var id = $this.data('id');

    $.post(call, { action: 'UpdateAantal', id: id, value: $number.val() }, function(data) {
        window.location.href = window.location.href;
    });
}

function updateMethod(e) {

    var $container = $(this).closest('.bestand-sticker-container');
    var $label = $(this).closest('.bestand-afhandeling-keuze');
    var disabled = $label.data('disabled');
    var type = $label.data('type');

    var id = $container.data('id');

    var $upload = $container.find('label[data-type=upload]');
    var $online = $container.find('label[data-type=online]');
    var $later = $container.find('label[data-type=later]');

    if(type === 'upload')
    {
        hideOnlineOntwerp($online);
        showUploadOntwerp($upload);
    }
    if(type === 'online'){
        if(disabled) {
            $online.find('.bestand-optie-radio-item-leeg').removeClass("radio-aan-kleur");
            $online.find('.bestand-optie-radio-item-vol').removeClass("radio-aan");
            $online.removeClass('.bestand-afhandeling-keuze-selected');
        }else {
            hideUploadOntwerp($upload);
            showOnlineOntwerp($online);
        }

    }
    if(type === 'later') {
        hideUploadOntwerp($upload);
        hideOnlineOntwerp($online);
    }
    if(!disabled || disabled === undefined) {
        $.post(window.location.href, {action: 'UpdateMethod', method: type, id: id});
    }
}

function showUploadOntwerp($upload) {
    var $img = $upload.find('img.image');
    if($img.attr('src')) {
        $img.parent().show();
        $img.show();
        $upload.find('.text').hide();
        $upload.find('.verwijder-ontwerp').show();
        $upload.find('.afbeelding-plaatsen-upload-winkelwagen-container').hide();
    }else{
        var $a = $upload.find('.bestand');
        if($a.attr('href')) {
            $a.parent().show();
            $a.show();
            $img.hide();
            $upload.find('.text').hide();
            $upload.find('.verwijder-ontwerp').show();
            $upload.find('.afbeelding-plaatsen-upload-winkelwagen-container').hide();
        }else {
            $upload.find('.afbeelding-plaatsen-upload-winkelwagen-container').show();
        }
    }
}
function hideUploadOntwerp($upload) {
    var $img = $upload.find('img.image');
    $img.parent().hide();
    $upload.find('.text').show();
    $upload.find('.verwijder-ontwerp').hide();

    if(!$img.attr('src')) {
        $upload.find('.afbeelding-plaatsen-upload-winkelwagen-container').show();
    }
}

function showOnlineOntwerp($this) {
    if($this.find('img').attr('src')) {
        //$this.find('img').show();
        $this.find('.verwijder-ontwerp').show();
        $this.find('.text').hide();
        $this.find('.ontwerpen-btn').hide();
    }else{
        $this.find('.ontwerpen-btn').show();
    }
}

function hideOnlineOntwerp($this)
{
    $this.find('img').hide();
    $this.find('.verwijder-ontwerp').hide();
    $this.find('.text').show();

    if ($this.find('img').attr('src')) {
        $this.find('.ontwerpen-btn').hide();
    } else {
        $this.find('.ontwerpen-btn').show();
    }
}

function verwijderOntwerp(e) {
    e.preventDefault();
    var $this = $(this);
    var id = $this.data('id');

    $.post($this.attr('href'), { id: id, action: 'DeleteDesign' }, function(data) {
        if(data === 'true') {
            $this.closest('.bestand-afhandeling-keuze').find('img.image').attr('src', '');
            $this.closest('.bestand-afhandeling-keuze').find('.bestand').attr('href', '');
            var $container = $this.closest('.bestand-sticker-container');
            var $upload = $container.find('label[data-type=upload]');
            var $online = $container.find('label[data-type=online]');

            var $label = $this.closest('.bestand-afhandeling-keuze');
            if($label.data('type') === 'online') {
                hideOnlineOntwerp($online);
            }else{
                hideUploadOntwerp($upload);
            }
        }
    });
    return false;
}

function setSpoedlevering(spoedlevering)
{
    $.fancybox.showLoading();
    $.ajax({
        type: 'post',
        url: window.location.href,
        data: {action: 'setSpoedlevering', spoedlevering:spoedlevering},
        success: function(data)
        {
            replaceContent(data);
            $.fancybox.hideLoading();
            initWinkelwagen();
        }
    });    
}

function toggleAlKlant(alKlant)
{
    if (alKlant)
    {
        $('#winkelwagen-inloggen-wrapper').show().find(':input').attr('required', true);
        $('#nieuwe-klant-wrapper').hide();
        $('#winkelwagen-wrapper-thuisadres :input').each(function(){
            $(this).attr('required', false);
        });
    }
    else
    {
        $('#winkelwagen-inloggen-wrapper').hide();
        $('#inloggen-email').attr('required', false).empty().val('');
        $('#inloggen-wachtwoord').empty().val('');
        $('#nieuwe-klant-wrapper').show(); 
        $('#winkelwagen-wrapper-thuisadres :input').each(function(){
            if ($(this).attr('data-required') == 'true')    
            {
                $(this).attr('required', true);
            }
        });    
    }
}

function toggleZakelijk(isZakelijk)
{
    if (isZakelijk)
    {
        $('.toon-zakelijk').show();
        $(':input[name="thuisadres[bedrijfsnaam]"]').attr('required', true);
        if ($(':input[name="thuisadres[land]"]').val() == 'be')
        {
            $('.btwnummer').show();
            $(':input[name="order[btwnummer]"]').attr('required', true);
        }
        else
        {
           $('.btwnummer').hide();
           $(':input[name="order[btwnummer]"]').attr('required', false);    
        }
    }
    else
    {
        $('.toon-zakelijk').hide();   
        $('.btwnummer').hide();
        $(':input[name="order[btwnummer]"]').attr('required', false); 
        $(':input[name="thuisadres[bedrijfsnaam]"]').attr('required', false);   
    }
}

function toggleAfwijkendAdres(type, afwijkendAdres)
{
    if(afwijkendAdres)
    {
        jQuery('#afwijkend-' + type + '-container').slideDown(700);
        $('#afwijkend-' + type + '-container').show();
        $('#afwijkend-' + type + '-container :input').each(function(){
            if ($(this).attr('data-required') == 'true')    
            {
                $(this).attr('required', true);
            }
        });
    }
    else
    {
        jQuery('#afwijkend-' + type + '-container').slideUp(700);
        $('#afwijkend-' + type + '-container :input').each(function(){
            $(this).attr('required', false);
        });
    }
}

function handleInloggen()
{
    if ($(':input[name="inloggen-email"]').val().length > 0 && $(':input[name="inloggen-wachtwoord"]').val().length > 0)
    {
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            url: window.location.href,
            data: {action: 'Inloggen', email: $(':input[name="inloggen-email"]').val(), wachtwoord: $(':input[name="inloggen-wachtwoord"]').val() },
            success: function(data)
            {
                var response = data[0];
                if (response == '0')    
                {
                    $.fancybox('<h1>Inloggen</h1><p>Ongeldige e-mailadres / wachtwoord combinatie</p>');
                }
                else
                {
                    $.ajax({
                        url: window.location.href,
                        success: function(data)
                        {

                            replaceContent(data);
                            initWinkelwagen();
                            $.fancybox.hideLoading();
                        }
                    })
                }
            }
        });
    }
}

function checkWachtwoorden(form)
{
    if ($('#wachtwoord').length > 0)
    {
        var wachtwoord1 = $('#wachtwoord').val();
        var wachtwoord2 = $('#wachtwoord_2').val();
        if ( (wachtwoord1.length > 0 || wachtwoord2.length > 0) && wachtwoord1 != wachtwoord2)
        {
            $.fancybox('<h1>Account aanmaken</h1><p>Opgegeven wachtwoorden komen niet overeen.</p>');
            return false;
        }
    }
    return true;
}

function checkBestaandEmailadres(form)
{

}

var preventDefault = true;
function submitStap3(preventDefault)
{
    if(!preventDefault) return true;
    if(preventDefault) event.preventDefault();
    var form = $('#form-gegevens');

    if (checkWachtwoorden($(this)))
    {
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            url: window.location.href,
            data: {action: 'checkBestaandEmailadres', email: $(':input[name="order[email]"]').val()},
            success: function(data)
            {
                var response = data[0];
                if (response == '1')
                {
                    preventDefault = false;
                    form.submit();

                    $.fancybox.hideLoading();
                }
                else
                {
                    $.fancybox('<h1>Bestaand e-mailadres</h1><p>Er bestaat al een account met opgegeven e-mailadres</p>');
                }
            }
        });
    }
    return false;

}
